module.exports = __webpack_public_path__ + "media/images/product/p_c-8386b4c62d61c647c2a36322bbff1279.png";